import { Component, OnInit, AfterViewInit, Injectable, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { DataView } from 'primeng/dataview';
import { NotificationService, DialogService, PagedResult, PagedSearch, DatagridService, UtilService } from '../../shared/index'; //app/shared/index barrel;
import { EventsService } from '../shared/events.service';
import { BusyIndicatorComponent } from '../../shared/widgets/busy-indicator/busy-indicator.component';
import { EventsContextSearchComponent } from '../search/context-search-input/events-context-search-input.component';
import { EventSearchParams } from '../search/event-search-params.model';
import { ConfigSettingService } from '../../config/shared/config-setting/config-setting.service';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { AuthService } from '../../shared/auth/auth.service';

@Component({
  selector: 'wl-events-left-nav',
  templateUrl: 'event-left-nav.component.html',
  styleUrls: ['event-left-nav.component.css'],
  providers: [EventsService, ConfigSettingService],
    standalone: false
})
@Injectable()
export class EventLeftNavComponent implements AfterViewInit {
  @ViewChild('upcomingEventsDataGrid', { static: false }) public upcomingEventsDataGrid: DataView;

  public _lastSearchParams: any;
  public _dataIntiallyLoaded: boolean;

  public errorMessage: string;
  public upcomingEvents: PagedResult;
  public recentlyViewed: PagedResult;
  public searchResults: PagedResult;
  public searchParams: EventSearchParams;
  public isSearching: boolean;
  public maxResults: number = 5;

  public constructor(
    public _navService: NavigationService,
    public _dialogService: DialogService,
    public _eventsService: EventsService,
    public _dataGridService: DatagridService,
    public _utilService: UtilService,
    public _authService: AuthService,
    public _configSettingService: ConfigSettingService
  ) {
    this.upcomingEvents = new PagedResult();
    this.recentlyViewed = new PagedResult();
    this.searchResults = new PagedResult();
    this.errorMessage = '';
    this.searchParams = new EventSearchParams();
    this.searchParams.SearchDateBegin = new Date(2000, 0, 1, 0, 0, 0, 0);
    this.isSearching = false;

    this._lastSearchParams = null;
  }

  ngAfterViewInit() {
    if (this._authService.currentUserIsAuthenticated()) {
      this._configSettingService.getConfigSetting('', 'EventsSpa', 'QuickSearchMaxResults').then((data: any) => {
        if (data) this.maxResults = data.value;
        this.loadUpcomingEvents();
        this.loadRecentlyViewedEvents();
      });

      //datagrid/search param paging config
      //the dataGrid variable will only exist AfterViewInit
      //this._dataGridService.applyPagingDefaults(this.upcomingEventsDataGrid, this.searchParams);
    }
  }

  public searchEvents = (): Promise<any> => {
    this.isSearching = true;
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = this.maxResults;
    this.searchParams.OrderBy = 'StartDate:desc';

    return this._eventsService.quickSearchEvents(this.searchParams).then(
      (data: any) => {
        this.isSearching = false;
        this.searchResults = data;
      },
      (error: any) => {
        this.isSearching = false;
        this._dialogService.error(error);
      }
    );
  };

  public loadUpcomingEvents = (): Promise<any> => {
    this.isSearching = true;
    let upcomingSearchParams = new EventSearchParams();
    upcomingSearchParams.PageNumber = 1;
    upcomingSearchParams.PageSize = this.maxResults;
    upcomingSearchParams.OrderBy = 'StartDate:asc';

    return this._eventsService.quickSearchEvents(upcomingSearchParams).then(
      (data: any) => {
        this.isSearching = false;
        this.upcomingEvents = data;
      },
      (error: any) => {
        this.isSearching = false;
        this._dialogService.error(error);
      }
    );
  };

  public loadRecentlyViewedEvents = (): Promise<any> => {
    this.isSearching = true;
    let recentSearchParams = new EventSearchParams();
    recentSearchParams.PageNumber = 1;
    recentSearchParams.PageSize = this.maxResults;
    recentSearchParams.OrderBy = 'StartDate:desc';

    return this._eventsService.getRecentlyViewed(recentSearchParams).then(
      (data: any) => {
        if (data) this.recentlyViewed = data;

        this.isSearching = false;
      },
      (error: any) => {
        this.isSearching = false;
        this._dialogService.error(error);
      }
    );
  };

  public searchChanged = (newSearchParams: any): void => {
    this.searchParams = newSearchParams;
    this.searchEvents();
  };

  public handleSearchSubmit(event?: any): void {
    this.loadUpcomingEvents();
  }

  public loadEventDetail = (): void => {
    this._navService.navigateToEvent(1);
  };
}
